import { Product } from './Product';

export type Order = {
  id: string;
  orderNumber: string;
  userId: number | null;
  addressId?: string; // ID wybranego adresu
  subTotalPrice: number;
  totalPrice: number;
  deliveryPrice: number;
  deliveryMethod: DeliveryMethod;
  paymentStatus: PaymentStatus;
  paymentIntentId?: string;
  paczkomat?: string;
  packageNumber?: string;

  // Order Statuses
  orderStatus: OrderStatus;
  deliveryStatus: DeliveryStatus;
  cancellationReason?: OrderCancellationReason;
  cancellationMessage?: string;

  // Customer Information - dostosowane do modelu adresu
  fullName?: string;
  street?: string;
  buildingNumber?: string;
  apartmentNumber?: string;
  city?: string;
  postalCode?: string;
  province?: string;
  phone?: string;
  email?: string;

  // Optional Company Information
  NIP?: string;
  companyName?: string;
  companyStreetAndNumber?: string;
  companyCity?: string;
  companyPostalCode?: string;

  createdAt: Date;
  updatedAt: Date;

  items: OrderItem[];
};

export type OrderCreationAttributes = Omit<
  Order,
  'id' | 'userId' | 'paymentStatus' | 'createdAt' | 'updatedAt'
>;

export type CreateOrderFromOfferAttributes = {
  // Customer Information - dostosowane do modelu adresu
  fullName?: string;
  street?: string;
  buildingNumber?: string;
  apartmentNumber?: string;
  city?: string;
  postalCode?: string;
  province?: string;
  phone?: string;
  email?: string;

  // Optional address
  addressId?: string; // ID wybranego adresu

  // Optional Company Information
  NIP?: string;
  companyName?: string;
  companyStreetAndNumber?: string;
  companyCity?: string;
  companyPostalCode?: string;

  // Optional paczkomat
  paczkomat?: string;
};

export enum DeliveryMethod {
  PACZKOMAT = 'paczkomat',
  KURIER_INPOST = 'kurier_inpost',
}

export enum PaymentStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  REFUNDED = 'refunded',
}

export enum OrderStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export enum DeliveryStatus {
  PENDING = 'pending',
  READY = 'ready',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
}

export enum OrderCancellationReason {
  CUSTOMER_REQUEST = 'customer_request',
  OUT_OF_STOCK = 'out_of_stock',
  OTHER = 'other',
}

export type OrderItem = {
  id: string;
  orderId: string;
  productId: number;
  productName: string;
  productPrice: number;
  quantity: number;
  subtotal: number;
  snapshot: object;
  returnedQuantity: number;

  product: Product;
};
